var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stage"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12C8 9.79086 9.79086 8 12 8H28C30.2091 8 32 9.79086 32 12V28C32 30.2091 30.2091 32 28 32H12C9.79086 32 8 30.2091 8 28V12ZM10 24.9415C10 24.0807 10.5543 23.3303 11.3997 23.1678C12.9135 22.8768 15.7031 22.5 20 22.5C24.2969 22.5 27.0865 22.8768 28.6003 23.1678C29.4457 23.3303 30 24.0807 30 24.9415V27.9384C30 28.8562 29.369 29.6217 28.4554 29.7093C27.0271 29.8463 24.4359 30 20 30C15.5641 30 12.9729 29.8463 11.5446 29.7093C10.631 29.6217 10 28.8562 10 27.9384V24.9415ZM24 18.2877C24 16.9272 22.1577 16.5873 20 16.5873C17.8305 16.5873 16 16.9396 16 18.3001C16 19.66 17.8423 20 20 20C22.1695 20 24 19.6476 24 18.2877ZM22.647 12.6455C22.647 11.1764 21.469 10 20 10C18.531 10 17.353 11.1764 17.353 12.6455C17.353 14.1141 18.531 15.2916 20 15.2916C21.469 15.2916 22.647 14.1141 22.647 12.6455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 123",
    d: "M20 25.5C16.2212 25.5 13.7136 25.1432 12.2888 24.8492C11.883 24.7655 11.5 25.0908 11.5 25.4368V27.7192C11.5 27.9497 11.649 28.1079 11.8342 28.1327C12.912 28.277 15.3337 28.5 20 28.5C24.6663 28.5 27.088 28.277 28.1658 28.1327C28.351 28.1079 28.5 27.9497 28.5 27.7192V25.4368C28.5 25.0908 28.117 24.7655 27.7112 24.8492C26.2864 25.1432 23.7788 25.5 20 25.5Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage);
export default __webpack_public_path__ + "static/media/Stage.41ccca32493d54a4d5dc30c7a52468b5.svg";
export { ForwardRef as ReactComponent };